import { useState, useEffect } from 'react'
import './SearchSignalProvider.css'
import { formatDate } from 'utils/date';
import { formatNumberWithSpaces } from 'utils/numbers';

const SearchSignalProvider = ({ selectSignalProvider, selectedSignalProvider, signalProviders, handleSearch, label, }) => {

  // const [search, setSearch] = useState('');


  // useEffect(() => {
  //   const delayDebounceFn = setTimeout(() => {
  //     handleSearch(search)
  //   }, 300)

  //   return () => clearTimeout(delayDebounceFn)
  // }, [search])

  const clear = () => {
    selectSignalProvider({})
  }

  console.log(signalProviders)

  return (
    <div className='search_signal_provider_container'>
      {selectedSignalProvider.uuid && (

        <div className={`${selectedSignalProvider?.uuid ? "search_signal_provider_selected" : "search_signal_provider_selected"} relative`}>
          <span onClick={() => selectSignalProvider(selectedSignalProvider)}>
            <div className='search_signal_provider_additional_infos'>
              <>
                <p>{selectedSignalProvider.signal_provider_name}</p>
                <p>{selectedSignalProvider.is_bot ? 'Bot' : selectedSignalProvider.email}</p>
              </>
            </div>

          </span>
          <div onClick={clear} className='delete_item_select'>x</div>
        </div>
      )}

      {!selectedSignalProvider.uuid && signalProviders.length > 0 && (
        <ul className='search_signal_providers_list_box'>
          {signalProviders.map((signal_provider, index) => (
            <li key={index} onClick={() => selectSignalProvider(signal_provider)} className="search_signal_provider_not_selected">
              <div className='search_signal_provider_item_selectMatchingSignalProvider'>
                <p>{signal_provider.signal_provider_name}</p>
                <p>{signal_provider.is_bot ? 'Bot' : signal_provider.email}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchSignalProvider